angular.module('tf.directives')

    .constant("rbacRoles", [
        'admin','manager','editor','viewer'
    ])

    .directive('rbac', ['rbacRoles', 'Session', function(rbacRoles, Session){
        return {
            restrict : 'A',
            scope : {
                rbac : '@'
            },
            link : function(scope, element, attrs){
                element.removeAttr('rbac');
                var userRole = Session.role;

                if(rbacRoles.indexOf(userRole) > rbacRoles.indexOf(scope.rbac)){
                    element.remove();
                }
            }
        };
    }])

    .service('rbac', ['rbacRoles', '$q', 'Session',function(rbacRoles, $q, Session){
        this.allow = function(role){
            var defer = $q.defer();
            var userRole = Session.role;
            if(rbacRoles.indexOf(userRole) <= rbacRoles.indexOf(role)){
                defer.resolve();
            } else {
                defer.reject();
            }
            return defer.promise;
        };
        return this;
    }])
;

